import { useTranslation } from "react-i18next";
import { BookOpen } from "lucide-react";
import { lt } from "../localize";
import type { LessonStage } from "../types";

interface StageIntroProps {
  stage: LessonStage;
}

export const StageIntro = ({ stage }: StageIntroProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="space-y-5">
      {/* Title card */}
      <div className="glass p-5 border-l-4 border-l-secondary">
        <h2 className="text-xl font-bold mb-2">{lt(stage.title, lang)}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {lt(stage.content, lang)}
        </p>
      </div>

      {/* Key points */}
      {stage.keyPoints && stage.keyPoints.length > 0 && (
        <div className="space-y-3">
          <div className="flex items-center gap-2 px-1">
            <BookOpen className="w-4 h-4 text-secondary" />
            <h4 className="text-xs font-semibold uppercase text-secondary tracking-wider">
              {t("learn_in_this_lesson")}
            </h4>
          </div>
          <div className="space-y-2">
            {stage.keyPoints.map((point, i) => (
              <div
                key={i}
                className="glass p-3.5 flex items-start gap-3"
              >
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-secondary/20 text-secondary text-xs font-bold shrink-0 mt-0.5">
                  {i + 1}
                </span>
                <span className="text-sm leading-relaxed">{lt(point, lang)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
